import { api } from "./api";

export const listarEventos = () => api.get("/evento/listar");
export const obterEvento = (id) => api.get(`/evento/${id}`);
export const getProvedoresPix = () => api.get("/evento/provedores-pix");
export const salvarEvento = (dto) => api.post("/evento/salvar", dto);
export const excluirEvento = (id) => api.post(`/evento/excluir/${id}`);
export const listarInscritosEvento = (id) => api.get(`/evento/${id}/inscritos`);

const query = (params = {}) =>
  new URLSearchParams(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")
  ).toString();

// Lista geral de inscritos (todos os eventos), com filtros.
export const listarInscritos = (params = {}) => {
  const qs = query(params);
  return api.get(`/evento/inscritos${qs ? `?${qs}` : ""}`);
};

// Salva um blob recebido da API como download no navegador.
const baixarBlob = (data, nomeArquivo) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = nomeArquivo;
  document.body.appendChild(a); a.click(); a.remove();
  window.URL.revokeObjectURL(url);
};

const baixarArquivo = async (rota, params, extensao) => {
  const qs = query(params);
  const { data } = await api.get(`${rota}${qs ? `?${qs}` : ""}`, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = `inscritos_${new Date().toISOString().slice(0, 10)}.${extensao}`;
  document.body.appendChild(a); a.click(); a.remove();
  window.URL.revokeObjectURL(url);
};

// Relatórios (respeitam os filtros da tela).
export const baixarInscritosExcel = (params = {}) => baixarArquivo("/evento/inscritos/excel", params, "xlsx");
export const baixarInscritosPdf = (params = {}) => baixarArquivo("/evento/inscritos/pdf", params, "pdf");

// Marca/desfaz a entrega da pulseira.
export const marcarPulseira = (idInscricao, entregue) =>
  api.post(`/evento/inscritos/${idInscricao}/pulseira`, { Entregue: entregue });

// ---- Financeiro ----
// Lista de cobranças (uma por inscrição/grupo), com filtros.
export const listarFinanceiro = (params = {}) => {
  const qs = query(params);
  return api.get(`/evento/financeiro/cobrancas${qs ? `?${qs}` : ""}`);
};

// Confirma o pagamento manualmente: data, forma de pagamento e comprovante (opcional).
export const confirmarPagamentoManual = (
  idCobranca, { dataPagamento, formaPagamento, valorPago, observacao, comprovante } = {}
) => {
  const fd = new FormData();
  if (dataPagamento) fd.append("DataPagamento", dataPagamento);
  if (formaPagamento) fd.append("FormaPagamento", formaPagamento);
  // Vazio = valor cheio da inscrição; menor = desconto concedido.
  if (valorPago != null && valorPago !== "") fd.append("ValorPago", valorPago);
  if (observacao) fd.append("Observacao", observacao);
  if (comprovante) fd.append("Comprovante", comprovante);
  return api.post(`/evento/cobranca/${idCobranca}/confirmar-pagamento`, fd, { headers: { "Content-Type": undefined } });
};

export const comprovacaoPagamento = (idCobranca) =>
  api.get(`/evento/cobranca/${idCobranca}/comprovacao`);

export const estornarPagamentoManual = (idCobranca) =>
  api.post(`/evento/cobranca/${idCobranca}/estornar-pagamento`);

// Abre o comprovante (respeita o token) em nova aba.
export const abrirComprovante = async (idCobranca) => {
  const { data } = await api.get(`/evento/cobranca/${idCobranca}/comprovante`, { responseType: "blob" });
  const url = window.URL.createObjectURL(data);
  window.open(url, "_blank");
  setTimeout(() => window.URL.revokeObjectURL(url), 60000);
};

// Inscrição administrativa (admin inscreve um responsável por CPF).
export const buscarResponsavel = (cpf) =>
  api.get(`/evento/responsavel?cpf=${encodeURIComponent(cpf)}`);
export const buscarMatriculasResponsavel = (cpf) =>
  api.get(`/evento/responsavel/matriculas?cpf=${encodeURIComponent(cpf)}`);
export const inscreverAdmin = (dto) => api.post("/evento/inscrever-admin", dto);

// Presença / encontros
export const listarEncontros = (idEvento) => api.get(`/evento/${idEvento}/encontros`);
export const participantesEncontro = (idEncontro, termo) =>
  api.get(`/evento/encontro/${idEncontro}/participantes${termo ? `?termo=${encodeURIComponent(termo)}` : ""}`);
export const marcarPresenca = (idInscricao, idEncontro, presente) =>
  api.post("/evento/presenca", { IdInscricao: idInscricao, IdEncontro: idEncontro, Presente: presente });
// Token do QR Code do encontro (rotacionar = invalida o QR anterior).
export const tokenEncontro = (idEncontro, rotacionar = false) =>
  api.post(`/evento/encontro/${idEncontro}/token${rotacionar ? "?rotacionar=true" : ""}`);

// Certificado
export const uploadArteCertificado = (idEvento, tipo, arquivo) => {
  const fd = new FormData();
  fd.append("arquivo", arquivo);
  return api.post(`/evento/certificado/${idEvento}/arte/${tipo}`, fd, { headers: { "Content-Type": undefined } });
};
export const removerArteCertificado = (idEvento, tipo) =>
  api.post(`/evento/certificado/${idEvento}/arte/${tipo}/remover`);
export const definirParticipacao = (idInscricao, tipoParticipacao, cargaHoraria) =>
  api.post(`/evento/inscricao/${idInscricao}/participacao`, { TipoParticipacao: tipoParticipacao, CargaHoraria: cargaHoraria });
export const situacaoCertificado = (idInscricao) =>
  api.get(`/evento/inscricao/${idInscricao}/certificado/situacao`);
export const baixarCertificadoAdmin = async (idInscricao, forcar = false) => {
  const r = await api.get(`/evento/inscricao/${idInscricao}/certificado${forcar ? "?forcar=true" : ""}`, { responseType: "blob" });
  baixarBlob(r.data, `certificado_${idInscricao}.pdf`);
};
export const bannerUrl = (id) => `/api/evento/banner-img/${id}`;

export const uploadBanner = (id, arquivo) => {
  const fd = new FormData();
  fd.append("arquivo", arquivo);
  return api.post(`/evento/banner/${id}`, fd, { headers: { "Content-Type": undefined } });
};
